$(document).ready(function(){
    /*====域名配置====*/
    const domain = 'http://feature.people.com.cn'
    /*===Tip模块===*/
    function tipModule(){
      
    }
    tipModule.prototype.addHtml = function(text){
       var tipHtml = '<div class="alertBox"><h3>'+ text +'</h3></div><div class="blackBg"></div>';
       $('body').append(tipHtml);
    }
    tipModule.prototype.addStyle = function(){
        var styleObject = '<style>'
            styleObject += '.alertBox{width:35%;position:fixed;z-index: 1000;top:50%;border-radius:10px;border:2px solid #f3c297;left:50%;height:auto;text-align:center;padding:2vh 0;background:#e2e2e2;transform: translate(-50%,-50%);}.alertBox h3{font-size:18px;color:#0879e3;font-weight:normal;}',
            styleObject += '.blackBg{background:#000;opacity: 0.6;width: 100%;height: 100vh;z-index: 999;position: fixed;top:0px;left:0px;}',
            styleObject += '</style>'
        
        $('body').append(styleObject);
    }
    tipModule.prototype.addStyleError = function(){
        var styleObject = '<style>'
            styleObject += '.alertBox{width:35%;position:fixed;z-index: 1000;top:50%;border-radius:10px;border:2px solid #f3c297;left:50%;height:auto;text-align:center;padding:2vh 0;background:#e2e2e2;transform: translate(-50%,-50%);}.alertBox h3{font-size:18px;color:#d00;font-weight:normal;}',
            styleObject += '.blackBg{background:#000;opacity: 0.6;width: 100%;height: 100vh;z-index: 999;position: fixed;top:0px;left:0px;}',
            styleObject += '</style>'
        
        $('body').append(styleObject);
    }
    tipModule.prototype.clearAlert = function(){
        $('.alertBox').remove();
        $('.blackBg').remove();
    }
    tipModule.prototype.alertTip = function(text){
        tipObject.addHtml(text);
        tipObject.addStyle();
        setTimeout(function(){
           tipObject.clearAlert();
        },1500)
     }
     tipModule.prototype.alertTipError = function(text){
        tipObject.addHtml(text);
        tipObject.addStyleError();
        setTimeout(function(){
           tipObject.clearAlert();
        },1500)
     }
     tipModule.prototype.loading = function(text){
        tipObject.addHtml(text);
        tipObject.addStyle();
     }

     var tipObject = new tipModule();

    /*====上传模块===*/
    function upModule(){
       //上传通用接口
       this.smsApi = domain + "/api/sendsms";
       this.upApi = domain + '/api/articles/add_jiangsuphotopc'
       this.fileApi = 'http://djyadmin.people.com.cn/api/uploadFile'
    }
    //获取验证码
    upModule.prototype.getSms = function(){
            var phone = $('#phone').val();
            if(phone == ''){
                tipObject.alertTip('请输入手机号')
                return false
            }
            $.ajax({
                type: "Post",
                url: upObject.smsApi,
                data:{'phone':phone},		 
                dataType: "json",
                success: function(res){
                  if(res.data.status == 0){
                    tipObject.alertTip(res.message)
                    localStorage.setItem('code',res.data.code)
                    $('#getCode').hide();
                    $('#getCode1').show();
                    var time = 60;
                    var Timer = setInterval(function () {
                        $('#getCode1').html(time-- + "s");
                        if (time == 0) {
                        clearInterval(Timer);
                            $('#getCode').show();
                            $('#getCode1').hide();
                        }
                    }, 1000);
                  }else{
                    tipObject.alertTip(res.msg)
                  }
                },
                error:function (error) {
                    var msg = JSON.parse(error.responseText);
                    tipObject.alertTipError(msg.message)
                }
            })
    }

    //上传图片
    upModule.prototype.upImg = function(file){

        var formData = new FormData();
        formData.append('fileStream', file); 

        tipObject.loading('图片上传中...')

        $.ajax({
            type: 'POST',
            url: 'http://djyadmin.people.com.cn/api/uploadFile',
            data: formData,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function(res) {
                // console.log('上传图片信息:', res)
                if(res.code == 0000) {
                  tipObject.clearAlert();
                  tipObject.alertTip(res.msg)
                  $('.imgList').show();
                  $('#cover').val(res.data.sql)
                  $('#imgObject').attr('src',res.data.sql);
                }
            },
            error:function (error) {
                var msg = JSON.parse(error.responseText);
                tipObject.alertTipError(msg.message)
            }
        })
    }

    //上传模块实例调用
    var upObject = new upModule();

    //获取验证码动作
    $('#getCode').on('click',function(){
        upObject.getSms();
    })
    //上传图片
    $('#upIMG').on('change', function(event) {
        var evt = event || window.event;
        var target = evt.target || evt.srcElement
        var files = target.files,
            file;
        if(files && files.length > 0) {
            // 获取目前上传的文件
            file = files[0];

            if(!/jpg|png/ig.test(file.name)) {
                tipObject.alertTipError('请上传jpg或png格式文件');
                return false;
            }
            if(file.size > 10485760){
                tipObject.alertTipError('单张图片大小不超过10M');
                return false;
            }

            upObject.upImg(file);
        } 
    
    });
    //提交信息
    $('#tijiao').on('click',function(){
       var smsmsg = $('#code').val();
       var nickname = $('#nickname').val();
       var name = $('#name').val();
       var mobilephone = $('#phone').val();
       var title = $('#title').val();
       var desc = $('#desc').val();
       var cover = $('#cover').val();

       if(nickname == ''){
        tipObject.alertTipError('昵称不能为空');
        return false
       }
       if(name == ''){
        tipObject.alertTipError('真实姓名不能为空');
        return false
       }
       if(mobilephone == ''){
        tipObject.alertTipError('手机号不能为空');
        return false
       }
       if(smsmsg == ''){
        tipObject.alertTipError('验证码不能为空');
        return false
       }
       if(title == ''){
        tipObject.alertTipError('作品名称不能为空');
        return false
       }
       if(desc == ''){
        tipObject.alertTipError('作品简介不能为空');
        return false
       }
       if(cover == ''){
        tipObject.alertTipError('需要上传一张作品图片');
        return false
       }

       let data = {
            nickname:title,
            name:name,
            smsmsg:smsmsg,
            mobilephone:mobilephone,
            title:title,
            desc:desc,
            cover:cover,
        }

        $.ajax({
            type: 'POST',
            url: upObject.upApi,
            data:data,
            dataType: 'json',
            success: (res) => {
                    console.log('提交数据:',res)
                    
                    if(res.data){
                        tipObject.alertTip(res.message);
                        $('.reset input').val('');
                        $('.reset textarea').val('');
                        $('.imgList').hide();
                    }else{
                        tipObject.alertTipError(res.message);
                    }
            },
        }).fail(function (err) {
            console.log(err)
        })
    })
    //重置信息
    $('.resetButton').on('click',function(){
        $('.reset input').val('');
        $('.reset textarea').val('');
        $('.imgList').hide();
    })
    //重置图片
    $('.clear').on('click',function(){
        $('.imgList').hide();
        $('#imgObject').attr('src','');
        $('#cover').val('');
    })

    /*====结束上传模块===*/




    /*====作品列表+点赞功能===*/
    function list(){
        //通用接口
        this.listApi = domain + "/api/jiangsuphotolist";
        //通用存储
        this.listArray = [];
        this.page = 1;
        this.status = 'created_at';
    }

    list.prototype.load = function(page,status){
        return new Promise(function (resolve, reject) {
            $.ajax({
                type: 'GET',
                url:listObject.listApi+'?limit=8&page='+page+'&orderby='+status,
                dataType: 'json',
                processData: false,
                contentType: false,
                success: function(res) {
                    console.log('作品列表:', res)
                    if(res.message == 'success'){
                        resolve({
                            'data':res.data
                        })
                    }
                },
                error:function (error) {
                    var msg = JSON.parse(error.responseText);
                    tipObject.alertTipError(msg.message)
                }
            })
        })
    }
    list.prototype.zanLoad = function(datas){
        // console.log('数据:',datas)
        var data = datas.data.data;
        var les = data.length;
        var max = datas.data.total;
        var listHtml = "";
        for (let index = 0; index < les; index++) {
            listHtml += '<div class="item"><img src="'+data[index].cover+'" alt=""><p>'+data[index].title+'</p><h3>昵称:'+data[index].nickname+'</h3><div class="zanBox"><img class="zanButton" src="static/images/zan.png" alt=""><span>'+data[index].like_num+'</span></div></div>'
         }
        $('.zuoBox').append(listHtml)
        var maxles = $('.zuoBox .item').length;
        // console.log(max)
        if(maxles == max){
            $('.addMore').hide();
        }else{
            $('.addMore').show();
        }
    }

    var listObject = new list();

    listObject.load(listObject.page,listObject.status).then((res) =>{
       listObject.zanLoad(res);
    })

    $('.zuoTab span').on('click',function(){
        var index = $(this).index();
        $('.zuoTab span').removeClass('active');
        $('.zuoTab span').eq(index).addClass('active');
        if(index == 0){
            $('.zuoBox').html('');
            listObject.status = 'created_at';
            listObject.page = 1;
            listObject.load(1,'created_at').then((res) =>{
                listObject.zanLoad(res);
            })
        }else{
            $('.zuoBox').html('');
            listObject.status = 'like_num';
            listObject.page = 1;
            listObject.load(1,'like_num').then((res) =>{
                listObject.zanLoad(res);
             })
        }
    })

    $('.addMore').on('click',function(){
         console.log('状态:',listObject.status)
         listObject.page = listObject.page + 1;
         listObject.load(listObject.page,listObject.status).then((res) =>{
            listObject.zanLoad(res);
         })
    })

})